import { render, staticRenderFns } from "./DialogRolesUsuarioNuevo.vue?vue&type=template&id=4dd39255"
import script from "./DialogRolesUsuarioNuevo.vue?vue&type=script&lang=js"
export * from "./DialogRolesUsuarioNuevo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports